// skeleton/app/src/app/user-management/user-management.component.ts

import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import type { NavigationExtras } from '@angular/router';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { forkJoin, Observable, observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {
  ButtonActionType,
  ButtonColors,
  ButtonSize,
  ButtonStyle,
  ButtonType,
} from 'src/app/shared/components/inputs/button/button.model';
import { ModalSize } from 'src/app/shared/components/view/modal/modal.model';
import { Constants } from 'src/app/shared/constants';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';
import { GroupModel, UserModel } from '../admin/models/group.model';
import { Table } from 'primeng/table';
import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';
import { OrganizationModel } from '../admin/models/organization.model';
import { CardModel } from '../shared/components/view/card/card.model';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { ParamService } from '../shared/services/param.service';
import {
  faAlignJustify,
  faAngleLeft,
  faAngleRight,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import { NgxSpinnerService } from 'ngx-spinner';
import { v4 as uuidv4 } from 'uuid';
import { StorageService } from '../shared/services/token-storage.service';

export interface PeriodicElement {
  groupId: string;
  groupName: string;
  groupDescription: string;
}

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class UserManagementComponent implements OnInit {
  arrowIconToggle: boolean = false;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faUserCircle = faUserCircle;
  faAlignJustify = faAlignJustify;

  cards: CardModel[] = [];
  Isdataloaded: boolean = false;

  selectedOrgGroupList: string[] = [];
  selectedOrganizationName: string = '';
  selectedOrganizationDesc: string = '';
  constant: Constants = new Constants();

  icons = {
    faTimes: faTimes,
  };

  IsOrgEdit: boolean = false;
  faSearch = faSearch;

  groupTitle = 'Group Details';
  modalSize = ModalSize.Small;
  modalText = 'Organization Details';
  hidePopUp: boolean = true;
  hideGroupPopUp: boolean = true;

  modalbtnText = 'SAVE';
  modalbtncancelText = 'CANCEL';
  modalbtnMedium = ButtonSize.Medium;
  modalbtnWithText = ButtonStyle.Textonly;
  modalbtnRect = ButtonType.Rectangle;
  modalbtnBlue = ButtonColors.Blue;

  showgroupContainer: boolean = false;

  btnSaveText = 'SAVE';
  btnEditText = 'EDIT';
  btnDeleteText = 'DELETE';
  btnDeleteActionType = ButtonActionType.Button;
  btnLarge = ButtonSize.Large;
  btnPlus = ButtonStyle.PlusIcon;
  btnRnd = ButtonType.Round;
  btnColor = ButtonColors.Blue;

  btnMedium = ButtonSize.Medium;
  btnSmall = ButtonSize.Small;

  btnClose = ButtonStyle.Textonly;
  btnColorDef = ButtonColors.Red;

  selectedOrgName: string;
  selectedOrgDesc: string;

  orgName: string;
  orgDescription: string;

  orgid: string;
  grpID: string;
  groupName: string;
  bindgrp: [];
  groupDescription: string;

  masterOrgs: OrganizationModel[] = [];
  masterGroups: GroupModel[] = [];
  organizations: OrganizationModel[] = [];
  groups: GroupModel[] = [];

  group: GroupModel = new GroupModel();
  Organization: OrganizationModel = new OrganizationModel();

  cols: any;
  masterUsers: UserModel[] = [];
  users: UserModel[] = [];
  user: UserModel;

  deleteModalSize = ModalSize.Small;
  deleteModalText = 'Confirmation Message';
  hideDeletePopUp: boolean = true;
  deleteModalbtnText = 'Yes';
  deleteModalbtncancelText = 'No';
  deleteGroupFromOrg: GroupModel;

  hideDeleteOrgPopUp: boolean = true;
  userActivity: UserActivityLogModel = new UserActivityLogModel();

  data: PeriodicElement[] = [];
  displayedColumns: string[] = ['groupName', 'groupDescription', 'Actions'];

  size = 5;
  pageIndex = 0;
  dataSource: any;

  filter: {};
  selectedOrgEdit;

  imagePath: any;
  isImagePath = false;

  loggedInUserTypeId: string = '';
  loggedInUserTypeDesc: string = '';
  selectedOrgIdInPanel: string = '';

  deletePopup: any;

  constructor(
    private baseHttpService: BaseHttpService,
    private router: Router,
    private notificationService: NotificationService,
    private globalsession: GlobalsessionhandlerService,
    private paramservice: ParamService,
    private spinnerService: NgxSpinnerService,
    private storage: StorageService
  ) {}

  @ViewChild('searchUserInstance', { static: false }) searchUserInstance: ElementRef;
  @ViewChild('dt', { static: false }) public dataTable: Table;

  confirmOrgDelete() {
    this.deleteOrganization();
  }

  closeOrgDelete() {
    this.hideDeleteOrgPopUp = true;
  }

  closeDelete() {
    this.hideDeletePopUp = true;
    this.deleteGroupFromOrg = new GroupModel();
  }

  closeGroup() {
    this.groupName = '';
    this.hideGroupPopUp = true;
  }

  close() {
    this.hidePopUp = true;
  }

  getAllOrganization() {
    this.spinnerService.show();
    this.Isdataloaded = false;

    const orgs$ = this.baseHttpService.get(this.constant.getAllOrgs);
    forkJoin([orgs$]).subscribe(async results => {
      this.masterOrgs = results[0];
      this.masterOrgs.filter(x => x.groups.length > 0);
      this.spinnerService.hide();
    });
  }

  searchUserformatter = (user: UserModel) => user.fullName;
  resultUserformatter = (user: UserModel) => user.fullName + '( ' + user.email + ' )';

  public set selectedUser(value: UserModel) {
    if (value !== undefined) {
      this.user = value;
      this.searchUserInstance.nativeElement.value = value.fullName;
    }
  }

  async ngOnInit() {
    this.loggedInUserTypeId = this.storage.get('LoggedInUserTypeId');
    this.loggedInUserTypeDesc = this.storage.get('LoggedInUserTypeDesc');
    this.selectedOrgIdInPanel = this.storage.get('selectedOrgInPanel');

    this.loadAllOrganization();
  }

  loadAllOrganization() {
    this.spinnerService.show();

    let userlogObj: UserActivityLogModel = JSON.parse(this.storage.get('UserActivityLog'));

    const orgs$ = this.baseHttpService.get(this.constant.getAllOrgs);
    forkJoin([orgs$]).subscribe(results => {
      this.masterOrgs = [];
      this.masterOrgs = results[0];

      // filter only admin groups
      if (this.loggedInUserTypeDesc == 'Group Admin') {
        this.masterOrgs = this.masterOrgs.map(org => {
          org.groups = org.groups?.filter(group =>
            group.users?.some(user => user.userTypeDesc === 'Group Admin')
          );
          return org;
        });
      }

      // Add deleted users to all groups
      this.masterGroups.forEach(element => {
        element.deletedUsers = [];
      });

      this.sortOrgsByName();

      if (this.masterOrgs.length > 0) {
        if (userlogObj != null) {
          if (userlogObj.actionItem == 'Organization') {
            let orgSel = this.masterOrgs.filter(x => x.organizationId == userlogObj.actionId)[0];
            this.selectOrganization(orgSel);
            this.storage.remove('UserActivityLog');
          } else if (userlogObj.actionItem == 'Group') {
            let grpObj = JSON.parse(userlogObj.newValue);
            let orgSel = this.masterOrgs.filter(x => x.organizationId == grpObj.OrganizationId)[0];
            this.selectOrganization(orgSel);
            this.storage.remove('UserActivityLog');
          }
        } else {
          if (this.selectedOrgIdInPanel != null && this.selectedOrgIdInPanel.length > 0) {
            let orgSel = this.masterOrgs.filter(x => x.organizationId == this.selectedOrgIdInPanel)[0];
            this.selectOrganization(orgSel);
          } else {
            this.selectOrganization(this.masterOrgs[0]);
          }
        }
      }

      this.spinnerService.hide();
    });
  }

  paginate(event: any) {
    if (event == 0) {
      event = 1;
    }
    this.pageIndex = event;
    this.dataSource = this.data.slice(event * this.size - this.size, event * this.size);
  }

  onChange(id: string, selectedValue: any) {
    let organizations = this.masterOrgs;
    this.selectedOrgGroupList = [];

    for (let i = 0, len = organizations.length; i < len; i++) {
      if (organizations[i].organizationName == selectedValue) {
        this.selectedOrganizationName = organizations[i].organizationName;
        this.selectedOrganizationDesc = organizations[i].description;

        if (organizations[i].groups.length > 0) {
          let groupname = organizations[i].groups;
          groupname = groupname.filter(x => x.isDefault == false);
          let filterGroupname = groupname;

          for (let j = 0, len = filterGroupname.length; j < len; j++) {
            this.selectedOrgGroupList.push(filterGroupname[j].groupName);
          }
        }
        return;
      }
    }
  }

  changeArrowIcon() {
    this.arrowIconToggle = !this.arrowIconToggle;
  }

  navigateCreate(event: any) {
    this.hidePopUp = false;
  }

  OpenModalPopUp() {
    this.orgName = '';
    this.orgDescription = '';
    this.hidePopUp = false;
  }

  OpenModalPopUpForGroup() {
    this.groupName = '';
    this.groupDescription = '';
    this.hidePopUp = true;
    this.hideGroupPopUp = false;
  }

  editGroup(grp: any) {
    this.group = grp;
    this.groupName = grp.groupName;
    this.groupDescription = grp.groupDescription;
  }

  addGroup() {
    this.spinnerService.show();

    if (
      this.groupName == '' ||
      this.groupName == null ||
      this.groupDescription == '' ||
      this.groupDescription == null
    ) {
      this.notificationService.showError('Please enter all fields', 'Error');
      this.spinnerService.hide();
      return;
    } else if (
      this.masterGroups.find(g => g.groupName.trim().toLowerCase() == this.groupName.trim().toLowerCase())
    ) {
      this.notificationService.showError(
        'Group name already exists.  Please enter a new group name.',
        'Error'
      );
      this.spinnerService.hide();
      return;
    }

    this.group = {
      organizationId: this.Organization.organizationId,
      groupId: this.guid(),
      groupName: this.groupName,
      groupDescription: this.groupDescription,
      isDefault: false,
      users: [],
      isActive: true,
      isSelected: true,
    };

    let userActivityObj = this.buildUserActivityOject('Create', 'Group');
    this.group.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.baseHttpService.post(this.constant.createGroup, this.group).subscribe((groupId: string) => {
      this.notificationService.showSuccess('Group has been created successfully.', 'Successful!');
      this.group.groupId = groupId;

      this.masterGroups.push(this.group);
      this.dataTable.reset();
      this.masterGroups = this.masterGroups.filter(x => x.isDefault == false);
      this.groups = this.masterGroups;

      this.group = new GroupModel();
      this.groupName = '';
      this.groupDescription = '';
      this.hideGroupPopUp = true;
      this.spinnerService.hide();
    });
  }

  buildUserActivityOject(action: string, actionItem: string): UserActivityLogModel {
    this.userActivity = new UserActivityLogModel();
    this.userActivity.action = action;
    this.userActivity.actionItem = actionItem;
    return this.userActivity;
  }

  newRow() {
    return { Name: '' };
  }

  searchOrganization(searchText: string) {
    if (searchText.trim() != '') {
      this.organizations = this.masterOrgs.filter(g =>
        g.organizationName.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.organizations = JSON.parse(JSON.stringify(this.masterOrgs));
    }
    this.Organization = this.organizations[0];
  }

  searchGroup(searchText: string) {
    if (searchText.trim() != '') {
      this.groups = this.masterGroups.filter(g =>
        g.groupName.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.groups = JSON.parse(JSON.stringify(this.masterGroups));
    }
  }

  EditOrganization() {
    this.IsOrgEdit = true;
  }

  selectOrganization(selectedOrg: OrganizationModel) {
    this.isImagePath = false;
    this.size = 5;
    this.data = [];
    this.dataSource = [];
    this.showgroupContainer = true;

    this.selectedOrgEdit = selectedOrg;
    this.Organization = selectedOrg;

    if (this.Organization && this.Organization.logoImage) {
      this.imagePath = `data:image/jpg;base64,${this.Organization.logoImage}`;
      this.isImagePath = true;
    }

    if (this.Organization && this.Organization.groups) {
      this.dataSource = this.Organization.groups.filter((x: any) => x.isDefault === false);
    } else {
      this.dataSource = this.Organization;
    }

    this.data = this.dataSource;

    if (this.data && Array.isArray(this.data)) {
      this.dataSource = this.data.slice(0, 5);
    }

    this.masterGroups = this.dataSource;
    this.organizations.forEach(obj => (obj.isSelected = false));
    this.Organization.isSelected = true;

    this.selectedOrgName = this.Organization.organizationName;
    this.selectedOrgDesc = this.Organization.description;

    this.storage.set('selectedOrgInPanel', this.Organization.organizationId);
  }

  deleteSelectedOrg() {
    this.hideDeleteOrgPopUp = false;
  }

  SaveSelectedOrg() {
    if (
      this.selectedOrgName == null ||
      this.selectedOrgDesc == null ||
      this.selectedOrgName == '' ||
      this.selectedOrgDesc == ''
    ) {
      this.notificationService.showError('Please enter all fields', 'Error');
      return;
    } else if (
      this.masterOrgs.find(
        g =>
          g.organizationId != this.Organization.organizationId &&
          g.organizationName.trim().toLowerCase() == this.selectedOrgName.trim().toLowerCase()
      )
    ) {
      this.notificationService.showError(
        'Organization name already exists.  Please enter a new Organization name.',
        'Error'
      );
      return;
    }

    this.Organization = {
      organizationId: this.Organization.organizationId,
      organizationName: this.selectedOrgName,
      description: this.selectedOrgDesc,
      groups: this.Organization.groups,
      users: this.Organization.users,
      isActive: true,
      isSelected: true,
      logoFormat: '',
      logoImage: '',
      logoSize: 0,
    };

    let userActivityObj = this.buildUserActivityOject('Update', 'Organization');
    this.Organization.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.spinnerService.show();
    this.baseHttpService.post(this.constant.updateOrganization, this.Organization).subscribe((organizationId: string) => {
      this.notificationService.showSuccess('Organization details saved successfully.', 'Successful!');

      let selectedindex = this.masterOrgs.filter(x => x.organizationId == this.Organization.organizationId)[0];
      let indexoforg = this.masterOrgs.indexOf(selectedindex);
      this.masterOrgs.splice(indexoforg, 1);

      this.Organization.organizationName =
        this.Organization.organizationName[0].toUpperCase() +
        this.Organization.organizationName.substr(1, this.Organization.organizationName.length - 1);

      this.masterOrgs.push(this.Organization);
      this.IsOrgEdit = false;

      this.sortOrgsByName();
      this.selectOrganization(this.Organization);
      this.hidePopUp = true;
      this.spinnerService.hide();
    });
  }

  CancelEditOrganization() {
    this.selectedOrgDesc = this.Organization.description;
    this.selectedOrgName = this.Organization.organizationName;
    this.IsOrgEdit = false;
  }

  deleteOrganization() {
    this.spinnerService.show();

    let userActivityObj = this.buildUserActivityOject('Delete', 'Organization');
    this.Organization.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.baseHttpService.post(this.constant.deleteOrganization, this.Organization).subscribe((organizationId: string) => {
      this.notificationService.showSuccess('Organization has been deleted successfully.', 'Successful!');
      this.hidePopUp = true;
      this.hideDeleteOrgPopUp = true;
      this.loadAllOrganization();
      this.spinnerService.hide();
    });
  }

  hideGroupContainer() {
    this.showgroupContainer = false;
  }

  createOrganization() {
    this.spinnerService.show();

    if (
      this.orgName == '' ||
      this.orgName == null ||
      this.orgDescription == '' ||
      this.orgDescription == null
    ) {
      this.notificationService.showError('Please enter all fields', 'Error');
      this.spinnerService.hide();
      return;
    } else if (
      this.masterOrgs.find(g => g.organizationName.trim().toLowerCase() == this.orgName.trim().toLowerCase())
    ) {
      this.notificationService.showError(
        'Organization name already exists.  Please enter a new Organization name.',
        'Error'
      );
      this.spinnerService.hide();
      return;
    }

    this.Organization = {
      organizationId: this.guid(),
      organizationName: this.orgName,
      description: this.orgDescription,
      groups: [],
      users: [],
      isActive: true,
      isSelected: false,
      logoFormat: '',
      logoImage: '',
      logoSize: 0,
    };

    let userActivityObj = this.buildUserActivityOject('Create', 'Organization');
    this.Organization.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.baseHttpService.post(this.constant.createOrganization, this.Organization).subscribe((organizationId: string) => {
      this.notificationService.showSuccess('Organization has been created successfully.', 'Successful!');

      this.Organization.organizationId = organizationId;
      this.Organization.organizationName =
        this.Organization.organizationName[0].toUpperCase() +
        this.Organization.organizationName.substr(1, this.Organization.organizationName.length - 1);

      this.Organization.users = [];
      this.Organization.groups = [];
      this.Organization.deletedUsers = [];

      this.masterOrgs.push(this.Organization);

      this.sortOrgsByName();
      this.selectOrganization(this.Organization);

      this.hidePopUp = true;
      this.spinnerService.hide();
    });
  }

  Create_EditOrganization(org: any) {
    this.Organization = org;

    if (org == undefined || org == null) {
      this.router.navigate(['/create/createOrganization']);
    } else {
      const queryParams: any = {};
      this.bindgrp = org.groups;
      queryParams.myArray = JSON.stringify(org.groups);

      const navigationExtras: NavigationExtras = {
        queryParams,
      };

      this.orgName = org.organizationName;
      this.orgDescription = org.description;
      this.orgid = org.organizationId;

      this.router.navigate([
        '/create/createOrganization',
        {
          grpList: navigationExtras,
          orgid: this.orgid,
          orgName: this.orgName,
          orgDescription: this.orgDescription,
          orgLogoInfo: this.isImagePath ? this.imagePath : null,
        },
      ]);
    }
  }

  Create_Editgroup(grp: any) {
    if (grp == undefined || grp == null) {
      this.router.navigate(['/create/createGroup', { orgid: this.Organization.organizationId }]);
    } else {
      this.groupName = grp.groupName;
      this.groupDescription = grp.groupDescription;
      this.orgid = grp.organizationId;
      this.grpID = grp.groupId;

      this.router.navigate([
        '/create/createGroup',
        { grpid: this.grpID, orgid: this.orgid, grpname: this.groupName, grpdesc: this.groupDescription },
      ]);
    }
  }

  updateGroup(form: NgForm) {
    this.spinnerService.show();

    if (
      this.groupName == '' ||
      this.groupName == null ||
      this.groupDescription == '' ||
      this.groupDescription == null
    ) {
      this.notificationService.showError('Please enter all fields', 'Error');
      this.spinnerService.hide();
      return;
    }

    this.masterGroups.splice(this.masterGroups.indexOf(this.group), 1);

    let updtgroup: any = {
      organizationId: this.Organization.organizationId,
      groupId: this.group.groupId,
      groupName: this.groupName,
      groupDescription: this.groupDescription,
      isActive: true,
      isSelected: true,
      userActivityLog: null,
    };

    let userActivityObj = this.buildUserActivityOject('Update', 'Group');
    updtgroup.userActivityLog = userActivityObj != null ? userActivityObj : null;

    this.baseHttpService.post(this.constant.updateGroupName, updtgroup).subscribe((groupId: string) => {
      this.notificationService.showSuccess('Group has been updated successfully.', 'Successful!');

      this.group.groupName = this.groupName;
      this.group.groupDescription = this.groupDescription;

      this.masterGroups.push(this.group);

      this.groupName = '';
      this.groupDescription = '';

      this.group = new GroupModel();
      this.groups = this.masterGroups.filter(x => x.organizationId == this.Organization.organizationId);

      this.spinnerService.hide();
    });
  }

  CancelEdit(grp: any) {
    this.group = new GroupModel();
  }

  confirmDelete() {
    this.spinnerService.show();

    let existingItem = this.masterGroups.find(i => i.groupId == this.deleteGroupFromOrg.groupId);
    if (this.masterGroups.indexOf(existingItem) > -1) {
      this.group = {
        organizationId: this.Organization.organizationId,
        groupId: existingItem.groupId,
        groupName: existingItem.groupName,
        groupDescription: existingItem.groupDescription,
        users: [],
        isDefault: false,
        isActive: false,
        isSelected: false,
      };

      let userActivityObj = this.buildUserActivityOject('Delete', 'Group');
      this.group.userActivityLog = userActivityObj != null ? userActivityObj : null;

      this.baseHttpService.post(this.constant.deleteGroup, this.group).subscribe((result: string) => {
        this.notificationService.showSuccess('Group has been deleted successfully.', 'Successful!');

        this.masterGroups.splice(this.masterGroups.indexOf(existingItem), 1);

        let updtGrp = this.masterGroups;
        this.dataSource = [];
        this.dataSource = this.masterGroups;
        this.groups = updtGrp;

        this.data = this.dataSource;
        this.dataSource = this.data.slice(0, 5);

        this.closeDelete();
        this.hideDeleteOrgPopUp = true;
        this.hideDeletePopUp = true;

        this.spinnerService.hide();
      });
    }
  }

  deleteGroup(grp: any) {
    this.deleteGroupFromOrg = grp;
    this.hideDeletePopUp = false;
  }

  private updateGroupList(organizationId: any) {
    this.spinnerService.show();
    this.baseHttpService.getById(this.constant.getGroupsByOrgId, organizationId).subscribe((resp: any) => {
      this.masterGroups = resp;
      this.masterGroups = this.masterGroups.filter(x => x.isDefault == false);
      this.dataSource = this.masterGroups;
      this.data = this.dataSource;
      this.spinnerService.hide();
    });
  }

  private guid() {
    return uuidv4();
  }

  private sortOrgsByName() {
    this.masterOrgs.sort((a, b) => {
      let nameA = a.organizationName.toUpperCase();
      let nameB = b.organizationName.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    this.organizations = this.masterOrgs;
  }

  Manage_groupUsers() {
    this.router.navigate(['/managegroupUser', { Organizationname: this.selectedOrgName }]);
  }
}
